import React from 'react';
import SkeletonBlock from './common/SkeletonBlock';
import './HomePageSkeleton.css';

// Swimlane skeleton rows only. The hero placeholder is rendered
// separately by HeroSkeleton at the hero's actual DOM position (above
// AnnouncementBanner) so it reserves the correct vertical space during
// loading. Keeping it here would place a second hero placeholder below
// ContinueReading — wrong position, double height.
//
// The number of rows and the card content blocks are calibrated to match
// the real homepage content height as closely as possible. The real
// homepage renders ~6 HorizontalScrollList sections (Trending, ContestStrip,
// Promoters' Picks, Fresh Finds, Community Favorites, Bingeworthy) plus a
// "Just Updated" grid. Each real section is ~493px (header + card with image
// + title + author + genres + stats). The skeleton must match this total
// height so the footer doesn't shift when data arrives (CLS).
const SWIMLANE_ROWS = 6;
const CARDS_PER_ROW = 6;
const GRID_ROWS = 2;
const GRID_CARDS_PER_ROW = 5;

const SkeletonCard = () => (
  <div className="home-page-skeleton__card">
    <SkeletonBlock width="100%" height="auto" radius="var(--radius-lg)" className="home-page-skeleton__card-cover" style={{ aspectRatio: '2 / 3' }} />
    <div className="home-page-skeleton__card-content">
      <SkeletonBlock width="85%" height="0.95rem" radius="0.3rem" />
      <SkeletonBlock width="60%" height="0.95rem" radius="0.3rem" />
      <SkeletonBlock width="70%" height="0.75rem" radius="0.3rem" />
      <div className="home-page-skeleton__card-genres">
        <SkeletonBlock width="50px" height="0.6875rem" radius="var(--radius-sm)" />
        <SkeletonBlock width="40px" height="0.6875rem" radius="var(--radius-sm)" />
        <SkeletonBlock width="55px" height="0.6875rem" radius="var(--radius-sm)" />
      </div>
      <div className="home-page-skeleton__card-divider" />
      <div className="home-page-skeleton__card-stats">
        <SkeletonBlock width="30px" height="0.85rem" radius="0.2rem" />
        <SkeletonBlock width="1px" height="24px" radius="0" />
        <SkeletonBlock width="30px" height="0.85rem" radius="0.2rem" />
      </div>
    </div>
  </div>
);

const HomePageSkeleton = () => (
  <div className="home-page-skeleton" aria-hidden="true">
    {Array.from({ length: SWIMLANE_ROWS }).map((_, rowIndex) => (
      <section className="home-page-skeleton__row" key={rowIndex}>
        <div className="container">
          <SkeletonBlock width="200px" height="1.6rem" radius="0.6rem" className="home-page-skeleton__row-title" />
        </div>
        <div className="home-page-skeleton__cards">
          {Array.from({ length: CARDS_PER_ROW }).map((_, cardIndex) => (
            <SkeletonCard key={cardIndex} />
          ))}
        </div>
      </section>
    ))}
    {/* "Just Updated" grid skeleton — matches the real grid section
        which uses home-collection__grid with auto-fill minmax(220px, 1fr).
        On desktop this is 5 columns; we render 2 rows to approximate the
        typical 10-12 novel grid height. */}
    <section className="home-page-skeleton__grid-section">
      <div className="container">
        <SkeletonBlock width="180px" height="1.6rem" radius="0.6rem" className="home-page-skeleton__row-title" />
      </div>
      <div className="container home-page-skeleton__grid">
        {Array.from({ length: GRID_ROWS * GRID_CARDS_PER_ROW }).map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    </section>
  </div>
);

export default HomePageSkeleton;
